module.exports = __webpack_public_path__ + "static/media/card-blog4.c2cea7c5.jpg";